'use strict';
import {DynamicPageService} from "../../services/dynamic-page/dynamic-page.service";

const angular = require('angular');

export class suiteEntityTemplateIterComponent {
  constructor(SettingsService, IntegrationService, DynamicPageService) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.SettingsService = SettingsService;
    this.IntegrationService = IntegrationService;
  }

  $onInit() {

      this.IntegrationService.suiteQueryCustomEntityByType({type: this.entity}, data => {
        this.data = data;

        this.DynamicPageService.getByName({name: this.template}, page => this.templateHtml = page.data);
      });
  }
}

export default angular.module('conduu.ap.components.suite-entity-template-iter', [])
  .component('suiteEntityTemplateIter', {
    template: require('./suite-entity-template-iter.component.html'),
    bindings: {
      entity: '@',
      template: '@'
    },
    controller: suiteEntityTemplateIterComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/suite-entity-template-iter/suite-entity-template-iter.component.js